import React from 'react'
import { Select } from 'components/select'
import { createFilterOptions } from 'store/modules/common/filters'

export const FilterOptions = ({ localize, column, update, classes }) => {
  const data = createFilterOptions(column.type, localize)
  const handleOnChange = React.useCallback((option) => update({ option }), [update])
  return (
    <div className={classes.filterOptions}>
      <Select
        data={data}
        value={column.option}
        onChange={handleOnChange}
      />
    </div>
  )
}